export interface IUploadCenterFileResult {
    success: boolean;
    fileName: string;
    message: string;
}